import React, { useEffect, useState, useRef } from "react";
import {
  Space,
  Tabs,
  Watermark,
  Button,
  Table,
  Modal,
  Form,
  Input,
  Spin,
  message,
} from "antd";
import axios from "axios";
import API from "@/api";

function Gllp(props) {
  const { id } = props;
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(1);
  const [size, setSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [type, setType] = useState("add");
  const [selectedRow, setSelectedRow] = useState({});
  const [refresh, setRefresh] = useState("");
  const [spinning, setSpinning] = useState(true);

  const formRef = useRef();

  useEffect(() => {
    setLoading(true);
    axios.get(API.getGllpList + `?modelId=${id}`).then((res) => {
      setData(res?.data?.result?.data || []);
      setTotal(res?.data?.result?.total || 0);
      setLoading(false);
      setSpinning(false);
    });
  }, [refresh]);

  // 复制到剪贴板函数
  const copyToClipboard = async (text) => {
    try {
      // 使用现代浏览器的Clipboard API
      await navigator.clipboard.writeText(text);

      // 更新状态以显示成功反馈
      // setIsCopied(true);
      // setShowTooltip(true);

      // 2秒后重置状态
      setTimeout(() => {
        // setIsCopied(false);
      }, 2000);

      // 3秒后隐藏提示
      setTimeout(() => {
        // setShowTooltip(false);
      }, 3000);
      message.success("复制成功");
    } catch (err) {
      console.error("复制失败:", err);
      // 降级方案：使用传统方法
      fallbackCopyTextToClipboard(text);
    }
  };

  // 降级方案：传统复制方法
  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // 避免屏幕滚动
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        // setIsCopied(true);
        // setShowTooltip(true);

        setTimeout(() => {
          // setIsCopied(false);
        }, 2000);

        setTimeout(() => {
          // setShowTooltip(false);
        }, 3000);
      }
    } catch (err) {
      console.error("降级复制方案也失败了:", err);
      // alert('复制失败，请手动选择文本进行复制');
    }
    message.success("复制成功");
    document.body.removeChild(textArea);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Spin spinning={spinning}>
        <Table
          bordered
          rowKey={"tokenId"}
          dataSource={data}
          columns={[
            {
              title: "序号",
              dataIndex: " ",
              width: 80,
              align: "center",
              render(val, row, index) {
                return index + 1;
              },
            },
            {
              title: "名称",
              dataIndex: "name",
            },
            {
              title: "已使用额度（token）",
              dataIndex: "usedQuota",
            },
            {
              title: "Key",
              dataIndex: "key",
              render(val) {
                return (
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        width: "60px",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {val}
                    </span>
                    <span
                      style={{
                        color: "#0000ffa5",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        copyToClipboard(val);
                      }}
                    >
                      复制
                    </span>
                  </div>
                );
              },
            },
            {
              title: "关联状态",
              dataIndex: "isRelated",
              render(val) {
                if (val) {
                  return "已关联";
                } else {
                  return "";
                }
              },
            },

            {
              title: "操作",
              dataIndex: "id",
              align: "center",
              render(val, row) {
                return (
                  <>
                    {row?.isRelated ? (
                      <>
                        <span
                          style={{
                            color: "#1890FF",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            axios
                              .post(API.qxgllp, { modelId: id, tokenId: val })
                              .then((res) => {
                                if (res?.data?.resultCode === 0) {
                                  message.success("取消成功");
                                  setRefresh(Math.random());
                                } else {
                                  message.error(res?.data?.errorMsg);
                                }
                              });
                          }}
                        >
                          取消关联
                        </span>
                      </>
                    ) : (
                      <>
                        <span
                          style={{
                            color: "#1890FF",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            axios
                              .post(API.gllp, { modelId: id, tokenId: val })
                              .then((res) => {
                                if (res?.data?.resultCode === 0) {
                                  message.success("关联成功");
                                  setRefresh(Math.random());
                                } else {
                                  message.error(res?.data?.errorMsg);
                                }
                              });
                          }}
                        >
                          关联
                        </span>
                      </>
                    )}
                  </>
                );
              },
            },
          ]}
          loading={loading}
        />
      </Spin>
    </div>
  );
}

export default Gllp;
